import React, { useState, useEffect, ReactNode } from 'react'
import { useContext } from 'react'
import { ShowModalConfig } from '@/shared/types/modal';

const ModalContext = React.createContext<{
    modal: ShowModalConfig | undefined;
    showModal: (config: ShowModalConfig) => void;
    hideModal: () => void;
    addData: (data: Record<string, unknown>) => void;
    data: Record<string, unknown>;
    isConfirmButtonDisabled: boolean;
    changeConfirmButtonState: (isEnabled: boolean) => void;
}>({
    modal: undefined,
    showModal: () => { },
    hideModal: () => { },
    addData: () => { },
    data: {},
    isConfirmButtonDisabled: false,
    changeConfirmButtonState: () => { },
})

const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [modal, setModal] = useState<ShowModalConfig | undefined>()
    const [data, setData] = useState<Record<string, unknown>>({})
    const [isConfirmButtonDisabled, setIsConfirmButtonDisabled] = useState<boolean>(false)

    useEffect(() => {
        return () => {
            hideModal()
        }
    }, [])

    const showModal = (config: ShowModalConfig) => {
        setModal(config)
    }

    const hideModal = () => {
        setModal(undefined)
    }

    const addData = (data: Record<string, unknown>) => {
        setData(data)
    }

    const changeConfirmButtonState = (isEnabled: boolean) => {
        setIsConfirmButtonDisabled(!isEnabled)
    }

    return (
        <ModalContext.Provider
            value={{
                data,
                modal,
                showModal,
                hideModal,
                addData,
                isConfirmButtonDisabled,
                changeConfirmButtonState,
            }}
        >
            {children}
        </ModalContext.Provider>
    )
}
const useModal = () => {
    const ctx = useContext(ModalContext)
    useEffect(() => {
        return () => {
            ctx.hideModal()
        }
        // hideModal only sets the state: the one of the first render is enough when the component unmounts
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return ctx
}

// the hook belongs to the context: the files that use it import both from here
// eslint-disable-next-line react-refresh/only-export-components
export { useModal, ModalContext, ModalProvider }
